import React from 'react';
import {
  HighlightedOfferColumn,
  OfferHeader,
  OfferHeading,
  OfferHeadingSubTitle,
} from './styles';
import { IOfferProps } from './types';
import { HighlightedOfferRow } from '../../price-list/price-row';

const HighlightedOffer: React.FC<IOfferProps> = props => {
  const { title, subtitle, ...otherProps } = props;
  return (
    <HighlightedOfferColumn>
      <OfferHeader>
        <OfferHeading>{title}</OfferHeading>
        <OfferHeadingSubTitle>{subtitle}</OfferHeadingSubTitle>
      </OfferHeader>
      <HighlightedOfferRow {...otherProps} />
    </HighlightedOfferColumn>
  );
};

export default HighlightedOffer;
